// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { redirect } from 'react-router';

import { store } from '../../../store/store';

import {
  fetchEquipmentGroupById,
  lockEquipmentGroup,
  unlockEquipmentGroup,
} from '../../../store/equipment/equipmentActions';
import { currentUserUuid, isUserAdmin } from '../../../store/user/userSelectors';
import { NODES_BASE_PATH } from '../../Routes/NodesRoutes/nodesBasePath';

export async function cameraControlLoader({ params }) {
  const { equipmentGroupId } = params;

  if (!equipmentGroupId) {
    return null;
  }

  // Redirects back to the equipment group page if the dispatched lock/unlock action was rejected.
  const redirectIfRejected = (action, thunkActionCreator) => {
    if (thunkActionCreator.rejected.match(action)) {
      throw redirect(`${NODES_BASE_PATH}/equipmentGroup/${equipmentGroupId}`);
    }
  };

  await store.dispatch(fetchEquipmentGroupById(equipmentGroupId));

  const state = store.getState();
  const group = state.equipment.selectedEquipmentGroup;

  if (group?.equip_group_uuid !== equipmentGroupId) {
    return null;
  }
  // React Router loader runs before the page renders, so the lock is acquired (or redirected away) before paint.
  const lockOwnerId = group?.lock?.[0]?.company_member?.user_id;

  if (!lockOwnerId) {
    const action = await store.dispatch(lockEquipmentGroup({ equip_group_uuid: equipmentGroupId }));
    redirectIfRejected(action, lockEquipmentGroup);
    return null;
  }

  if (lockOwnerId === currentUserUuid(state)) {
    return null;
  }

  if (!isUserAdmin(state)) {
    throw redirect(`${NODES_BASE_PATH}/equipmentGroup/${equipmentGroupId}`);
  }

  // Admin taking over someone else's lock: release it before claiming it
  const unlockAction = await store.dispatch(
    unlockEquipmentGroup({ equip_group_uuid: equipmentGroupId, cascade: true })
  );
  redirectIfRejected(unlockAction, unlockEquipmentGroup);
  const lockAction = await store.dispatch(
    lockEquipmentGroup({ equip_group_uuid: equipmentGroupId })
  );
  redirectIfRejected(lockAction, lockEquipmentGroup);

  return null;
}

cameraControlLoader.hydrate = true;
